// AI assisted development

/** Minimal shape for origin checks (Angular `environment`). */
export interface UpshopEmbedParentOriginEnv {
  isProd: boolean;
}

const LOCAL_DEV_PARENT_ORIGINS = new Set<string>([
  'http://localhost:3000',
  'http://127.0.0.1:3000',
  'https://localhost:3000',
  'http://localhost:5173',
  'http://127.0.0.1:5173',
]);

/**
 * Whether `postMessage` `event.origin` is trusted for Upshop Commerce embed (session bridge + parent nav).
 *
 * Allows HTTPS hosts under **`*.upshop.com`**, **`upshop360.com`**, **`*.upshop360.com`** (AppUI2-aligned), plus
 * localhost dev origins when `!isProd`.
 */
export function isAllowedUpshopEmbedParentOrigin(
  origin: string,
  env: UpshopEmbedParentOriginEnv,
): boolean {
  if (!origin) {
    return false;
  }
  if (matchesUpshopPlatformHttpsOrigin(origin)) {
    return true;
  }
  if (!env.isProd && LOCAL_DEV_PARENT_ORIGINS.has(origin)) {
    return true;
  }
  return false;
}

function matchesUpshopPlatformHttpsOrigin(origin: string): boolean {
  let url: URL;
  try {
    url = new URL(origin);
  } catch {
    return false;
  }
  if (url.protocol !== 'https:') {
    return false;
  }
  const h = url.hostname.toLowerCase();
  if (h === 'upshop360.com') {
    return true;
  }
  if (h.endsWith('.upshop360.com')) {
    return true;
  }
  if (h === 'upshop.com') {
    return true;
  }
  if (h.endsWith('.upshop.com')) {
    return true;
  }
  return false;
}
